import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getCareerMentorship} from '../../../Store/Actions/careerMentorship';
import CareerMentorshipComponent from '../../../Components/UserComponents/CareerMentorship';

const CareerMentorshipContainer = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const {allCareerMentorships} = useSelector(
    ({careerMentorship}) => careerMentorship,
  );

  useEffect(() => {
    if (allCareerMentorships) {
      setData(allCareerMentorships?.data?.career_mentorship[0]);
    }
  }, [allCareerMentorships]);

  useEffect(() => {
    fetchCareerMentorshipById();
  }, []);

  const fetchCareerMentorshipById = () => {
    dispatch(getCareerMentorship());
  };

  return (
    <div>
      <CareerMentorshipComponent data={data} />
    </div>
  );
};

export default CareerMentorshipContainer;
